import React,{useState,useEffect,useRef} from 'react';
//import { v4 as uuidv4 } from 'uuid';
import { connect } from 'react-redux';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import themeSettings from '../../../../commons/styles/themeSettings.json';
import { MASTERALGORITHM, RBSLOOKUPMaster } from '../../../../commons/api';
import { getMetaData, submitDataSource, getDeployHistory } from '../../Utils/FormCalls';
import {
  StyledSubHeading,
} from '../../CSS/style';
import {
  Button,
  Checkbox,
  Form,
  Input,
  Select,
  message,
  Space,
  Modal
} from 'antd';
const { Option } = Select;
const { TextArea } = Input;
const APIList = {
  getById: `${MASTERALGORITHM.GET}`,
  getMetrics: `${RBSLOOKUPMaster.LookUpItemsGetById}`,
  createAlgorithm: `${MASTERALGORITHM.CREATE}`
};
const AlgorithmMastersDetails = (props) => {
  const [formObject, setFormObject] = useState({});
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
 // const [typeList, setTypeList] = useState({});
  //const [subTypeList, setSubTypeList] = useState({});
  const [checkedVal, setCheckedVal] = useState('true');
  //const [modelVisible, setModelVisible] = useState(false);
 // const [newRecord, setNewRecord] = useState(false);
  const [parameterModal, setParameterModal] = useState(false);
  //const [AddParametrModal, setAddParametrModal] = useState(false);
  const [applicableMetricsList, setApplicableMetricsList] = useState([]);
  const [hyperParametersData, setHyperParametersData] = useState([]);
  const [parameters, setParameters] = useState([]);
  //const [dataSource, setDataSource] = useState([]);
  const [selectedModelType, setSelectedModelType] = useState('');
  const hRef = useRef(null);
  const dynamicFormRef = useRef(null);
  useEffect(() => {
    const fetchData = async () => {
      let path = props.location.pathname.split('/rubus/RbsAnalytics/AlgorithmMasterDetails/');
      let Id = path && path[1] ? path[1] : null;
      if (Id) {
        let data = await getMetaData(APIList.getById, 'Id', Id);
        let formObject = data && data[0] ? data[0] : {};
        setParameters( { users: formObject.HyperParameters });
        setHyperParametersData( formObject.HyperParameters);
        setSelectedModelType(formObject.ModelType);
        dynamicFormRef.current && dynamicFormRef.current.setFieldsValue({ users: formObject.HyperParameters });
        let applicableMetricsList = formObject.ModelType === 'Regression'
          ? await getDeployHistory(APIList.getMetrics, 'LookupName', 'RBS_MODEL_REG_METRICS')
          : await getDeployHistory(APIList.getMetrics, 'LookupName', 'RBS_MODEL_CLF_METRICS');
        setApplicableMetricsList(applicableMetricsList);
        setSelectedModelType(formObject.ModelType);
        setCheckedVal(formObject.GPUFlag === 'true' ? 'true' : 'false');
        if (hRef.current) {
          hRef.current && hRef.current.setFieldsValue(formObject );
        }
        {
        setFormObject(formObject);
      }
      }
  };  
    fetchData();
    },[props.location.pathname]);
  useEffect(() => {
    if (props.userProfile !== userProfile || props.translationCache !== translationCache) {
      setUserProfile(props.userProfile);
      setTranslationCache(props.translationCache);
    }
  }, [props.userProfile, props.translationCache]);
  // const handleSave = (dataSource) => {
  //   setDataSource(dataSource);
  //   setNewRecord(false);
  // };
  // const handleAdd = () => {
  //   const newData = {
  //     key: uuidv4(),
  //     Name: '',
  //     DefaultValue: '',
  //     Enabled: true
  //   };
  //   setDataSource([...dataSource, newData]);
  //   setNewRecord(true);
  // };
  // const disableSubmit = (disableSubmit) => {
  //   setNewRecord(false);
  // };
  const onFormSubmit = () => {
    hRef.current.validateFields()
      .then(async (values) => {
        values = {
          ...hRef.current.getFieldsValue(),
          GPUFlag: checkedVal,
          HyperParameters: hyperParametersData
        };
        let response = await submitDataSource(APIList.createAlgorithm, values);
        hRef.current && hRef.current.resetFields();
        message.success(response && response.message ? translation(response.message) : '');
        props.navigate('/rubus/RbsAnalytics/AlgorithmMasterList');
      })
      .catch(() => { });
  };
  const resetFields = () => {
    hRef.current && hRef.current.setFieldsValue({
      ModelType: null,
      AlgorithmName: '',
      ShortDescription: '',
      DetailedDescription: '',
      DependentLibraries: '',
      TemplateClass: null,
      ApplicableMetrics: []
    });
    setFormObject({});
    setHyperParametersData([]);
    setCheckedVal('true');
    setSelectedModelType('');
  };
  const onModelTypeChange = async (value) => {
    let applicableMetricsList = value === 'Regression'
      ? await getDeployHistory(APIList.getMetrics, 'LookupName', 'RBS_MODEL_REG_METRICS')
      : await getDeployHistory(APIList.getMetrics, 'LookupName', 'RBS_MODEL_CLF_METRICS');
    setApplicableMetricsList(applicableMetricsList);
    setSelectedModelType(value);
  };
  const onCheckboxChange = (e) => {
    setCheckedVal(e.target.checked ? 'true' : 'false');
  };
  const onSubmit = (values) => {
    setHyperParametersData(values.users);
    setParameterModal(false);
    setParameters ({ users: values.users });
  };
  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
    const validateMessages = {
      required: translation('${label}') + translation('is required!')
    };
    const formItemLayout = { width: '100%', flex: '50%' };
    return (
      <>
              <StyledSubHeading theme={themeSettings}>
               {translation('Algorithm Master')}
              </StyledSubHeading>
              <Form 
              name="AlgorithmMaster"
              ref={hRef}
              autoComplete="off"
              initialValues={formObject}
              theme={themeSettings}
              layout="horizontal"
              labelCol={{ flex: '200px' }}
              labelAlign="right"
              onFinish={onFormSubmit}
             // onFinishFailed={onFinishFailed}
              labelWrap
              validateMessages={validateMessages}
              wrapperCol={{ flex: 1 }}
              >
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                <Form.Item name="Id"></Form.Item>
                <Form.Item
                  label={translation('Model Type')}
                  name="ModelType"
                  rules={[{ required: true }]}
                  style={formItemLayout}
                >
                  <Select
                    style={{ width: '70%' }}
                    onChange={onModelTypeChange}
                    placeholder={translation('Please Select Model Type')}
                  >
                    <Option value={'Regression'} key={'Regression'}>
                      Regression
                    </Option>
                    <Option value={'Classification'} key={'Classification'}>
                      Classification
                    </Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  label={translation('Algorithm Name')}
                  name="AlgorithmName"
                  rules={[{ required: true }]}
                  style={formItemLayout}
                >
                  <Input
                    style={{ width: '70%' }}
                    placeholder={translation('Please Enter Algorithm Name')}
                  />
                </Form.Item>
                <Form.Item
                  label={translation('Short Description')}
                  name="ShortDescription"
                  style={formItemLayout}
                >
                  <TextArea placeholder={translation('Add Short Description')} style={{ width: '70%' }} />
                </Form.Item>
                <Form.Item
                  label={translation('Detailed Description')}
                  name="DetailedDescription"
                  style={formItemLayout}
                >
                  <TextArea placeholder={translation('Add Detailed Description')} style={{ width: '70%' }} />
                </Form.Item>
                <Form.Item
                  label={translation('Dependent libraries with versions')}
                  name="DependentLibraries"
                  style={formItemLayout}
                >
                  <TextArea placeholder={translation('Add Dependent Libraries')} style={{ width: '70%' }} />
                </Form.Item>
                <Form.Item
                  label={translation('Template class')}
                  name="TemplateClass"
                  style={formItemLayout}
                >
                  <TextArea placeholder={translation('Add Template class')} style={{ width: '70%' }} />
                </Form.Item>
                <Form.Item
                  label={translation('Best with GPU flag')}
                  name="GPUFlag"
                  style={formItemLayout}
                >
                  <Checkbox
                    checked={checkedVal === 'true'}
                    onChange={(e) => onCheckboxChange(e)}
                  />
                </Form.Item>
                <Form.Item
                  label={translation('Applicable metrics')}
                  name="ApplicableMetrics"
                  rules={[{ required: true }]}
                  style={formItemLayout}
                >
                  <Select
                    style={{ width: '70%' }}
                    mode="multiple"
                    disabled={selectedModelType ? false : true}
                    placeholder={translation('Please Select Applicable Metrics')}
                  >
                    {applicableMetricsList &&
                  Array.isArray(applicableMetricsList) &&applicableMetricsList.map((metrics) => (
                      <Option value={metrics.value} key={metrics.key}>
                        {metrics.key}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  label={translation('Hyper Parameters')}
                  name="HyperParameters"
                  style={formItemLayout}
                >
                  <Button
                    type="dashed"
                    onClick={() => {
                      setParameters({ users: hyperParametersData || [] });
                      dynamicFormRef.current && dynamicFormRef.current.setFieldsValue({
                        users: hyperParametersData || []
                      });
                      setParameterModal(true);
                    }}
                  >
                    {'...'}
                  </Button>
                </Form.Item>
                <Modal
                  open={parameterModal}
                  theme={themeSettings}
                  width={800}
                  closable
                  title={
                    formObject.HyperParameters ? 'Update Hyper Parameters' : 'Add Hyper Parameters'
                  }
                  onCancel={() => setParameterModal(false)}
                  footer={null}
                >
                  <Form
                    name="dynamic_form_nest_item"
                    onFinish={onSubmit}
                    autoComplete="off"
                    ref={dynamicFormRef}
                    initialValues={parameters}
                  >
                    <Form.List name="users">
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map(({ key, name, ...restField }) => (
                            <Space
                              key={key}
                              style={{ display: 'flex', marginBottom: 8 }}
                              align="baseline"
                            >
                              <Form.Item
                                {...restField}
                                name={[name, 'Name']}
                                rules={[{ required: true, message: 'Missing Name' }]}
                              >
                                <Input placeholder="Name" />
                              </Form.Item>
                              <Form.Item
                                {...restField}
                                name={[name, 'DefaultValue']}
                                rules={[{ required: true, message: 'Missing Default Value' }]}
                              >
                                <Input placeholder="Default Value" />
                              </Form.Item>
                              <MinusCircleOutlined onClick={() => remove(name)} />
                            </Space>
                          ))}
                          <Form.Item>
                            <Button
                              type="dashed"
                              style={{ width: '70%' }}
                              onClick={() => add()}
                              block
                              icon={<PlusOutlined />}
                            >
                              Add Parameter
                            </Button>
                          </Form.Item>
                        </>
                      )}
                    </Form.List>
                    <div style={{ display: 'flex', justifyContent: 'right', paddingLeft: '10px' }}>
                      <Form.Item>
                        <Button type="primary" style={{ marginRight: 8 }} htmlType="submit">
                          Submit
                        </Button>
                      </Form.Item>
                      <Form.Item>
                        <Button
                          key={'back'}
                          style={{ marginRight: 8 }}
                          onClick={() => setParameterModal(false)}
                        >
                          Cancel
                        </Button>
                      </Form.Item>
                    </div>
                  </Form>
                </Modal>
              </div>
              <div style={{ display: 'flex', justifyContent: 'right' }}>
                <Form.Item>
                  <Button
                    style={{ marginRight: 8 }}
                    theme={themeSettings}
                    type="primary"
                    htmlType="submit"
                    data-testid="submitButton"
                  >
                    {formObject && formObject.Id ? translation('Update') : translation('Submit')}
                  </Button>
                </Form.Item>
                <Form.Item>
                  <Button
                    style={{ marginRight: 8 }}
                    theme={themeSettings}
                    type="primary"
                    onClick={() => resetFields()}
                  >
                    {translation('Reset')}
                  </Button>
                </Form.Item>
              </div>
              </Form>
      </>
    );
};
const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile,
  translationCache: state.TranslationReducer.translationCache
});
export default connect(mapStateToProps)(AlgorithmMastersDetails);
